// extracted by mini-css-extract-plugin
export default {"buttonPanel":"SimpleButton_buttonPanel__ANUQR"};